module.exports = __webpack_public_path__ + "media/images/core_values/perseverance-cedd0aba2051eca4624f2fd964ba0fbd.png";